var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignandGraphics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5762 21.4016C10.5762 22.2232 9.91022 22.8892 9.08864 22.8892C8.26706 22.8892 7.60104 22.2232 7.60104 21.4016C7.60104 20.58 8.26706 19.914 9.08864 19.914C9.91022 19.914 10.5762 20.58 10.5762 21.4016Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.70012
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.141625,
    y: 1.27783,
    width: 2.85715,
    height: 20.7792,
    rx: 1.42857,
    transform: "matrix(0.780697 0.62491 -0.624909 0.780698 34.1719 4.45036)",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8213 8.03076L33.9505 9.73506",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5703 19.589L24.6995 21.2933",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8828 23.8658L22.4914 23.1906L21.1409 21.9732L20.5323 22.6485L21.8828 23.8658ZM19.7226 23.5467C19.3864 23.9196 19.4163 24.4945 19.7892 24.8306C20.1621 25.1668 20.7369 25.137 21.0731 24.7641L19.7226 23.5467ZM20.5323 22.6485L19.7226 23.5467L21.0731 24.7641L21.8828 23.8658L20.5323 22.6485Z",
    fill: "#2E2E2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5736 10.4924L6.75312 10.4924C5.03171 10.4924 3.63623 11.8879 3.63623 13.6093L3.63623 29.1937C3.63623 30.9151 5.03171 32.3106 6.75312 32.3106L33.2466 32.3106C34.968 32.3106 36.3635 30.9151 36.3635 29.1937V13.6093C36.3635 11.8879 34.968 10.4924 33.2466 10.4924L32.4697 10.4924V12.0508H33.2466C34.1073 12.0508 34.8051 12.7486 34.8051 13.6093L34.8051 29.1937C34.8051 30.0544 34.1073 30.7522 33.2466 30.7522H6.75312C5.89241 30.7522 5.19467 30.0544 5.19467 29.1937L5.19467 13.6093C5.19467 12.7486 5.89241 12.0508 6.75312 12.0508L28.5736 12.0508V10.4924Z",
    fill: "#2E2E2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53467 26.8561H10.6516",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.083 31.0475L14.083 11.4961",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2231 26.8561L30.9115 26.8561",
    stroke: "currentColor",
    strokeWidth: 1.81818,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53467 15.9471H10.6516",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignandGraphics);
export default __webpack_public_path__ + "static/media/Design and Graphics.d2e93fd4a05c8672c98eec77757847e9.svg";
export { ForwardRef as ReactComponent };